import * as moment from 'moment';

import HeaderDetailsBaseService from './headerDetails.baseService';

/**
 * This requires the use of ng-bind-html
 * <span ng-bind-html="$ctrl.origText | aptHighlight:$ctrl.stringToHighlight"
 * I originally intended to make this a directive or component but that turned out to be troublesome when using with the grid at least
 * so this turned out to be simpler and less code
 */
class HeaderDetailsContractService extends HeaderDetailsBaseService {
  dateFormat: string = 'MM/DD/YY';

  get contract() {
    return this.data;
  }

  get dataType() {
    return 'contract';
  }

  get id() {
    return this.contract.publishedId || this.contract.id;
  }

  get sellerName() {
    return this.contract.seller.name;
  }

  get categoryName() {
    return this.contract.category.name;
  }

  get typeDescription() {
    return 'Contract';
  }

  get contractPeriodStartDate() {
    let startDate = 0 || this.contract.effectiveDate;

    return moment(startDate).format(this.dateFormat);
  }

  get contractPeriodEndDate() {
    let startDate = 0 || this.contract.expirationDate;

    return moment(startDate).format(this.dateFormat);
  }
}

// TODO: Why isn't this just a service?
export default function HeaderDetailsContractFactory() {
  return function (contractData: any) {
    return new HeaderDetailsContractService(contractData);
  };
}
